import { useDrawer } from 'contexts/DrawerContext';

/* properties */
import { NewProperty } from 'drawers/properties/NewProperty';
import { EditProperty } from 'drawers/properties/EditProperty';
import { PropertyDetails } from 'drawers/properties/PropertyDetails';
import { ShareProperty } from 'drawers/properties/ShareProperty';

export const usePropertyDrawers = () => {
  const { openDrawer, setDrawerComponent } = useDrawer();

  /* properties */
  const openDrawerNewProperty = () => {
    openDrawer({ component: NewProperty });
  };
  const openDrawerEditProperty = () => {
    openDrawer({ component: EditProperty });
  };
  const openDrawerPropertyDetails = () => {
    openDrawer({ component: PropertyDetails });
  };
  const setDrawerPropertyDetails = () => {
    setDrawerComponent({ component: PropertyDetails });
  };
  const openDrawerShareProperty = () => {
    openDrawer({ component: ShareProperty });
  };

  return {
    /* properties */
    openDrawerNewProperty,
    openDrawerEditProperty,
    openDrawerPropertyDetails,
    setDrawerPropertyDetails,
    openDrawerShareProperty,
  };
};
